import { render, staticRenderFns } from "./Care.vue?vue&type=template&id=1adffa88"
import script from "./Care.vue?vue&type=script&lang=ts"
export * from "./Care.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports